import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import InputMask from 'react-input-mask';
import axios from "axios";

import auth from '../../../auth/';
import CanalSelect from "./CanalSelect.js"
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import CreateEmpresas from "../../clientes/Empresas/Create.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"


import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
            prefijo: "",
            numero: "",
            canal_id: null,
            departamento_id: null,
            empresa_id: null,
            prefijoabreviatura:"",
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        buttonClass: PropTypes.string
    }


    resetState() {
        this.setState({
            prefijo: "",
            numero: "",
            canal_id: null,
            departamento_id: null,
            empresa_id: null,
            prefijoabreviatura:""
        })
    }


    onChangeDepartamento(e) {
        var depto = e.pk;
        var newprefijo = e.abreviatura;
        var url = api.proyectos.solicitudes.getnumero + "?prefijo=" + newprefijo;
        axios.get(url, auth.header())
            .then((response) => {
                if (response.data.success) {
                    this.setState({
                        numero: response.data.numero,
                    });
                }
            });
        this.setState({ prefijo: newprefijo, departamento_id: depto, prefijoabreviatura: newprefijo });
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.proyectos.solicitudes.create}
                onSubmit={() => this.props.onSubmit()}
                successMessage={"La Solicitud ha sido creado con éxito."}
                title={"Nueva Solicitud"}
                buttonTitle={"Nueva Solicitud"}
                buttonIcon={"fa fa-plus fa-lg"}

                saveButton={true}
                buttonClass={this.props.buttonClass}
                closeButton={true}
                onClose={() => this.resetState()}
            >
                <Input type="hidden" name="codigo" value={
                    this.state.prefijo + "-" + this.state.numero
                    }
                />

                <Row>
                    <Col md={4} sm={4}>
                        <ParadigmaLabeledInput labelColumns={12} fieldColumns={12} label={"Grupo"}
                            inputComponent={<ParadigmaAsyncSeeker clearable={false} onChange={(data) => this.setState({ departamentopadre_id: data.pk })}
                                fieldName="" url={api.usuarios.grupos.select} value={this.state.departamentopadre_id} />} />
                    </Col>
                    <Col md={5} sm={5}>
                        <ParadigmaLabeledInput labelColumns={12} fieldColumns={12} label={"Subgrupo"}
                            inputComponent={<ParadigmaAsyncSeeker
                                disabled={!this.state.departamentopadre_id}
                                clearable={false} onChange={(e) => this.onChangeDepartamento(e)}
                                fieldName={"departamentointerno_id"}
                                url={api.usuarios.subgrupos.select + (this.state.departamentopadre_id ? "?grupo=" + this.state.departamentopadre_id : "")}
                                value={this.state.departamento_id} />} />
                    </Col>
                    <Col md={3} sm={3}>
                        <ParadigmaLabeledInput labelColumns={12} fieldColumns={12} label={"Número"}
                            inputComponent={<InputMask name="" className="form-control" mask="99999"
                                value={this.state.numero}
                                onChange={(event) => this.setState({ numero: event.target.value })}
                                type="text" />} />
                    </Col>
                </Row>

                <ParadigmaLabeledInput labelColumns={4} fieldColumns={3}
                    disabled label={"Código"} fieldName=""
                    value={
                        this.state.prefijo + "-" + this.state.numero
                    }
                />

                <ParadigmaLabeledInput labelColumns={4} fieldColumns={8} label={"Título"} fieldName={"nombre"} />

                <ParadigmaLabeledInput labelColumns={4} fieldColumns={8} label={"Forma de Contacto"}
                    inputComponent={<CanalSelect value={this.state.canal_id} onChange={(e) => this.setState({ canal_id: e.pk })} />} />


                <ParadigmaLabeledInput labelColumns={4} fieldColumns={8} label={"Empresa/Organización"}
                    inputComponent={<ParadigmaAsyncSeeker Create={CreateEmpresas} fieldName={"empresa_id"}
                        url={api.clientes.empresas.select} value={this.state.empresa_id} />} onChange={(e) => this.setState({ empresa_id: e.pk })} />

                <ParadigmaLabeledInput type={"textarea"} labelColumns={12}
                    rows={10}
                    fieldColumns={12} label={"Observaciones"} fieldName={"observaciones"} />

                <br />

            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento1/Create.js